import { Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";
import { IconWtts } from "components/Icons/IconWtts";
import { IconLetter } from "components/Icons/IconLetter";
import { IconHeadseat } from "components/Icons/IconHeadseat";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FooterImage from "assets/footer.png";
import LogoImage from "assets/logo.png";

export default function HelpModal({ open, onClose, fullModal }) {
  if (fullModal) {
    return (
      <Modal
        open={open}
        onClose={onClose}
        disableAutoFocus={true}
        sx={{
          maxWidth: "100dvw",
          width: "100dvw",
          p: 0,
        }}
      >
        <ContentModal
          borderRadius={"16px"}
          style={{
            width: "100dvw",
            maxWidth: "100dvw",
            borderRadius: 0,
            height: "100dvh",
            margin: 0,
            maxHeight: "100dvh",
            background: "#03172F",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", p: 0, top: 60, left: 100 }}
          >
            <ArrowBackIcon sx={{ color: "#fff", fontSize: "31px" }} />
          </IconButton>
          <Stack gap={"70px"}>
            <Stack textAlign="justify">
              <Typography
                color="#FFFFFF"
                fontWeight={700}
                fontSize="30px"
                mt="30px"
                textAlign={"center"}
              >
                Precisando de ajuda?
              </Typography>
              <Typography
                color="#FFFFFF"
                fontSize="15px"
                mt="10px"
                maxWidth={"600px"}
                textAlign={"center"}
                marginTop={"16px"}
                lineHeight={"20px"}
              >
                Entre em contato conosco pelo Whatsapp. Caso não tenha instalado
                em seu smartphone, envie um email que em breve entraremos em
                contato com você!
              </Typography>
            </Stack>

            <Stack sx={{ gap: "16px" }}>
              <Button
                variant="contained"
                sx={{
                  height: "55px",
                  color: "#fff",
                  borderRadius: "36px",
                  width: "100%",
                  background: "#00BD4C",
                }}
                onClick={() =>
                  window.open(
                    `https://api.whatsapp.com/send?phone=5511997770000`,
                    "_blank"
                  )
                }
              >
                WhatsApp
              </Button>
              <Button
                variant="outlined"
                sx={{
                  height: "55px",
                  color: "#fff",
                  borderRadius: "36px",
                  width: "100%",
                  border: `solid 1px #2CABF9`,
                }}
                onClick={() =>
                  window.open("mailto:cac@consigaz.com.br", "_blank")
                }
              >
                cac@consigaz.com.br
              </Button>
            </Stack>

            <Stack textAlign="justify">
              <Typography
                color="#FFFFFF"
                fontWeight={700}
                fontSize="30px"
                mt="30px"
                textAlign={"center"}
              >
                Pode nos ligar também!
              </Typography>
              <Typography
                color="#FFFFFF"
                fontSize="15px"
                mt="10px"
                maxWidth={"600px"}
                textAlign={"center"}
                marginTop={"16px"}
                lineHeight={"20px"}
              >
                Telefones da CAC (Central de atendimento ao cliente)
              </Typography>
              <Button
                variant="outlined"
                sx={{
                  height: "55px",
                  color: "#fff",
                  borderRadius: "36px",
                  width: "100%",
                  border: `solid 1px #2CABF9`,
                  marginTop: "45px",
                }}
              >
                0800 940 0244
              </Button>
              <Button
                variant="outlined"
                sx={{
                  height: "55px",
                  color: "#fff",
                  borderRadius: "36px",
                  width: "100%",
                  border: `solid 1px #2CABF9`,
                  marginTop: "16px",
                }}
              >
                (11) 4766-9400
              </Button>
            </Stack>
            <Stack alignItems={"center"}>
              {/* <Button
            variant="contained"
            color="secondary"
            sx={{
              height: "55px",
              color: "#fff",
              borderRadius: "36px",
              width: "100%",
              mt: 2,
            }}
            onClick={() => setCpfRequested(cpfField)}
            disabled={!isCpfValid}
          >
            Avançar
          </Button> */}
            </Stack>
          </Stack>
          <Stack>
            <>
              <img
                src={FooterImage}
                alt="footer"
                className="footer-image"
                style={{
                  pointerEvents: "none",
                  width: "100vw",
                  position: "fixed",
                  left: 0,
                  right: 0,
                  bottom: 0,
                }}
              />
              <img
                src={LogoImage}
                alt="Logo"
                className="footer-logo-image"
                style={{
                  pointerEvents: "none",
                  position: "fixed",
                  height: "5vw",
                  maxHeight: "50px",
                  right: "16vw",
                  bottom: "4.5vw",
                  transform: "translate(50%, 50%)",
                }}
              />
            </>
          </Stack>
        </ContentModal>
      </Modal>
    );
  }

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus={true}>
      <ContentModal
        borderRadius={"16px"}
        style={{
          width: "600px",
        }}
      >
        <Stack textAlign={"start"} p={"31px 38px"}>
          <Stack direction={"row"} alignItems={"center"} gap={"16px"}>
            <IconButton onClick={onClose} sx={{ p: 0 }}>
              <ArrowBackIcon
                sx={{
                  color: "#053462",
                  fontSize: "31px",
                }}
              />
            </IconButton>
            <Typography fontSize={"25px"} fontWeight={700}>
              Precisando de ajuda?
            </Typography>
          </Stack>

          <Typography
            mt={"18px"}
            fontSize={"14px"}
            fontWeight={500}
            color="#636363"
            align="justify"
            lineHeight={"120%"}
          >
            Entre em contato conosco pelo WhatsApp. Se você ainda não tiver o
            aplicativo instalado no seu smartphone, não tem problema! Envie-nos
            um e-mail e retornaremos o mais breve possível. Se preferir, você
            também pode ligar para os telefones do nosso CAC, listados abaixo.
          </Typography>
          <Stack
            alignItems={"center"}
            mt={"32px"}
            direction={"row"}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Stack
              p={"16px"}
              justifyContent={"center"}
              alignItems={"center"}
              sx={{ cursor: "pointer" }}
              bgcolor={"#053462"}
              borderRadius={"8px"}
              width={"15%"}
              height={"80px"}
              onClick={() =>
                window.open(
                  `https://api.whatsapp.com/send?phone=5511997770000`,
                  "_blank"
                )
              }
            >
              <IconWtts />
              <Typography fontWeight={600} fontSize={"12px"} color="#FFFFFF">
                WhatsApp
              </Typography>
            </Stack>
            <Stack
              p={"16px"}
              justifyContent={"center"}
              alignItems={"center"}
              sx={{ cursor: "pointer" }}
              bgcolor={"#053462"}
              borderRadius={"8px"}
              width={"15%"}
              height={"80px"}
              onClick={() =>
                window.open("mailto:cac@consigaz.com.br", "_blank")
              }
            >
              <IconLetter />
              <Typography fontWeight={600} fontSize={"12px"} color="#FFFFFF">
                Email
              </Typography>
            </Stack>
            <Stack
              p={"16px"}
              justifyContent={"center"}
              alignItems={"center"}
              borderRadius={"8px"}
              width={"15%"}
              height={"80px"}
              border={"2px solid #053462"}
            >
              <IconHeadseat />
              <Typography fontWeight={600} fontSize={"10px"} color="#053462">
                0800 940 0244
              </Typography>
            </Stack>
            <Stack
              p={"16px"}
              justifyContent={"center"}
              alignItems={"center"}
              borderRadius={"8px"}
              width={"15%"}
              height={"80px"}
              border={"2px solid #053462"}
            >
              <IconHeadseat />
              <Typography fontWeight={600} fontSize={"10px"} color="#053462">
                (11) 4766-9400
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </ContentModal>
    </Modal>
  );
}
